import * as React from 'react'

import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { ServiceSectionDetails } from '@user/components/Agreements/AgreementFormPacketDialog/ServiceSectionDetails'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import Stack from '@mui/material/Stack'

type Props = {
  service: ILeadOppProduct
  serviceFrequencies: IServiceFrequency[]
}

export function DraggableServiceCard(props: Props) {
  const { service, serviceFrequencies } = props

  return (
    <div>
      <Stack
        sx={{
          width: '100%',
          cursor: 'grab',
        }}
      >
        <ServiceSectionDetails
          agreementServices={[]}
          onChangeService={() => {}}
          serviceFrequencies={serviceFrequencies}
          service={service}
          draggable
        />
      </Stack>
    </div>
  )
}
